import{useWidgetConfig}from"./useWidgetConfig";/**
 * Retrieves the styles for a specific widget by its id. Returns an empty object when no styles
 * exist.
 *
 * @param {string} widgetId The ID of the widget to look for.
 * @param {number|undefined} [index=0] The optional index of the widget.
 * @returns {Object}
 */export function useWidgetStyles(widgetId){var index=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var _useWidgetConfig=useWidgetConfig(widgetId,index),_useWidgetConfig$styl=_useWidgetConfig.styles,styles=_useWidgetConfig$styl===void 0?{}:_useWidgetConfig$styl;return styles;}